module.exports = __webpack_public_path__ + "microsoft-teams-logo-68bb08153ac7fe16c0abb4a9191cc455.webp";